import axios from "axios";
import { HIDDEN_PROPERTY } from "./types";

const PROXY = process.env.REACT_APP_URL + "api/";

export const gethiddenList = () => async (dispatch) => {
  try {
    const res = await axios.get(`${PROXY}hidden`);

    dispatch({
      type: HIDDEN_PROPERTY,
      payload: res.data.result,
    });

    return res.data.result;
  } catch (err) {
    console.error(err);
    //   toast.error(err.response.data.message);
  }
};

export const unHideProperties = (id) => async (dispatch) => {
  const res = await axios.delete(`${PROXY}hidden/${id}`);
  return res;
};
